{phoneValidator, emailValidator, requiredFieldValidator} = require 'utils/validations'
validator = require 'utils/validate'

App.SettingsProfileController = Em.Controller.extend
  sipService: Em.inject.service('sip')

  userBinding: 'model'

  isSaving: false

  errors: {}

  teardown: ->
    @get('user').rollback()

  actions:
    ###
    # Сохраняет изменения
    ###
    saveUser: ->
      user = @get('user')

      userPhone = @get('user.phone')
      userLogin = @get('user.login')

      currentErrors = validator.useValidation({
        phone: userPhone,
        login: userLogin
      }, ()=> ({
        phone: if !Ember.isEmpty(userPhone) then phoneValidator(),
        login: [emailValidator(), requiredFieldValidator()]
      }))()
      @set('errors', currentErrors)
      return if Object.values(currentErrors).length

      @set('isSaving', true)

      user.save()
      .then =>
        @get('sipService').trigger('settingsUpdated')
      .catch =>
        false
      .finally =>
        @set('isSaving', false)

        # Разбираем ошибки валидации
        errors = user.get('errors')

        [ 'login', 'password' ].forEach (field) =>
          validationField = "errors.#{field}".camelize()
          if errors.has(field)
            message = errors.errorsFor(field).map (m) ->
              m.message
            .join(',')

            @set(validationField, message)
          else
            @set(validationField, null)

        errors.clear()
        @set('user.password', null)
        @set('user.password_confirmation', null)
      false

    discartChanges: ->
      @get('user').rollback()
      false
